export const pushGtmEvent = (params) => {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer?.push(params);
    }
}